import NavBar from "./components/Header/NavBar";
import AboutMe from "./components/AboutMe/AboutMe";
import Home from "./components/Header/Home";
import TechStack from "./components/TeckStack/TechStack";
import Projects from "./components/Projects/Projects";
import Timeline from "./components/Timeline/Timeline";
import Certificates from "./components/Certificates/Certificates.jsx";

function App() {
  return (
    <>
      <NavBar />
      <Home />
      <AboutMe />
      <TechStack />
      <Projects />
      <Timeline />
      <Certificates />
    </>
  );
}

export default App;
